var _rect, _mask, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#F0F0F0",
    rx: 11
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "zj2odxnfta",
    width: 17,
    height: 17,
    x: 12,
    y: 9,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12 9h16.881v16.775h-16.88V9z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#zj2odxnfta)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    fillRule: "evenodd",
    d: "M20.625 23.805c-1.325 0-2.4-1.031-2.497-2.331h4.993c-.096 1.3-1.172 2.33-2.496 2.33zm.782-10.713c.003-.032.02-.06.02-.092V9.985c0-.544-.443-.985-.987-.985s-.985.44-.985.985V13c0 .033.016.06.02.092-3.96.455-7.102 3.603-7.472 7.589-.04.427.308.793.736.793h3.418c.1 2.386 2.058 4.3 4.468 4.3s4.367-1.914 4.467-4.3h3.05c.428 0 .776-.366.736-.793-.37-3.986-3.51-7.134-7.47-7.59z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    fillRule: "evenodd",
    d: "M20.44 27.456c-.543 0-.984.44-.984.985v1.575c0 .544.44.984.985.984.544 0 .985-.44.985-.984V28.44c0-.544-.441-.985-.985-.985zM26.208 25.161c-.385-.384-1.009-.384-1.394 0-.384.385-.384 1.01 0 1.393l1.114 1.113c.192.192.444.288.696.288.251 0 .504-.096.696-.288.385-.384.385-1.008 0-1.393l-1.112-1.113zM14.673 25.161l-1.112 1.113c-.385.385-.385 1.01 0 1.393.192.192.445.288.696.288.252 0 .504-.096.696-.288l1.114-1.113c.384-.384.384-1.008 0-1.393-.385-.384-1.009-.384-1.394 0z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightSmall);
export default __webpack_public_path__ + "static/media/light_small.5de3ac120c2e5850f27f2b3e69c8ae0f.svg";
export { ForwardRef as ReactComponent };